export const PAGE_SIZE_10 = 10;
export const PAGE_SIZE_9 = 9;
export const CLEAN_AUTH = "CLEAN_AUTH";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const GET_PROFILE = "GET_PROFILE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const CLEAN_NAV = "CLEAN_NAV";

// export const ROLE_ADMIN = "admin";
export const ROLE_STAFF = "staff";

export const LANGUAGE_ES = {
  code: "es",
  label: "language.languages.es",
};
export const LANGUAGE_PT = {
  code: "pt",
  label: "language.languages.pt",
};

export const LANGUAGES = [LANGUAGE_ES, LANGUAGE_PT];

export const STATUS_IN_PROCESS = {
  code: "IN PROCESS",
  label: "status.inProcess",
};
export const STATUS_COMPLETE = {
  code: "COMPLETE",
  label: "status.complete",
};
export const STATUS_ERROR = {
  code: "ERROR",
  label: "status.error",
};
export const UPLOAD_STATUS = [STATUS_IN_PROCESS, STATUS_COMPLETE, STATUS_ERROR];

export const PENDING_EVALUATION = {
  code: "PENDING_EVALUATION",
  label: "forms.requestProvider.status.pendingEvaluation",
};

export const REQUEST_PROVIDER_STATUS_CLOSED = {
  code: "CLOSED",
  label: "forms.requestProvider.status.closed",
};

export const REQUEST_STATUS = [
  PENDING_EVALUATION,
  REQUEST_PROVIDER_STATUS_CLOSED,
];

export const BASIC_RESPONSE_YES = {
  code: "YES",
  label: "forms.response.yes",
};

export const BASIC_RESPONSE_NO = {
  code: "NO",
  label: "forms.response.no",
};

export const BASIC_RESPONSE_IDK = {
  code: "IDK",
  label: "forms.response.idk",
};

export const BASIC_RESPONSE_2 = [BASIC_RESPONSE_YES, BASIC_RESPONSE_NO];

export const BASIC_RESPONSE_3 = [
  BASIC_RESPONSE_YES,
  BASIC_RESPONSE_NO,
  BASIC_RESPONSE_IDK,
];

export const PERSON_TYPE_PERSON = {
  code: "0",
  label: "forms.requestProvider.personType.person",
};

export const PERSON_TYPE_LEGAL_ENTITY = {
  code: "1",
  label: "forms.requestProvider.personType.legalEntity",
};

export const PERSON_TYPES = [PERSON_TYPE_PERSON, PERSON_TYPE_LEGAL_ENTITY];

export const CREATE_FORM = "CREATE_FORM";
export const GET_FORM = "GET_FORM";
export const UPDATE_FORM = "UPDATE_FORM";
export const DELETE_FORM = "DELETE_FORM";
export const FILTER_FORM = "const FILTER_FORM";

export const CREATE_REQUEST_FORM_PROVIDER = "CREATE_REQUEST_FORM_PROVIDER";
export const GET_REQUEST_FORM_PROVIDER = "GET_REQUEST_FORM_PROVIDER";
export const UPDATE_REQUEST_FORM_PROVIDER = "UPDATE_REQUEST_FORM_PROVIDER";
export const DELETE_REQUEST_FORM_PROVIDER = "DELETE_REQUEST_FORM_PROVIDER";
export const FILTER_REQUEST_FORM_PROVIDER =
  "const FILTER_REQUEST_FORM_PROVIDER";

export const FORM_RESPONSE_YES = {
  code: 1,
  label: "response.yes",
};

export const FORM_RESPONSE_NO = {
  code: 2,
  label: "response.no",
};

export const FORM_RESPONSE_NA = {
  code: 3,
  label: "response.na",
};

export const FORMS_RESPONSE = [
  FORM_RESPONSE_YES,
  FORM_RESPONSE_NO,
  FORM_RESPONSE_NA,
];

export const FORM_STATUS_PENDING = {
  code: "PENDING",
  label: "formStatus.pending",
};

export const FORM_STATUS_DRAFT = {
  code: "DRAFT",
  label: "formStatus.draft",
};

export const FORM_STATUS_COMPLETED = {
  code: "COMPLETED",
  label: "formStatus.completed",
};

export const FORM_STATUS_REJECTED = {
  code: "REJECTED",
  label: "formStatus.rejected",
};

export const FORM_STATUS_FINISHED = {
  code: "FINISHED",
  label: "formStatus.finished",
};

export const FORMS_STATUS = [
  FORM_STATUS_PENDING,
  FORM_STATUS_DRAFT,
  FORM_STATUS_COMPLETED,
  FORM_STATUS_REJECTED,
  FORM_STATUS_FINISHED,
];

export const ROLE_ADMIN = "admin";

export const ROLE_SPEAKER = "speaker";

export const CENTER_FARM = {
  code: "FARM",
  label: "forms.center.constants.farm",
};

export const CENTER_INDUSTRY = {
  code: "INDUSTRY",
  label: "forms.center.constants.industry",
};

export const CENTER_TYPES = [CENTER_FARM, CENTER_INDUSTRY];

export const JANUARY = {
  code: 1,
  label: "forms.meeting.constants.january",
};
export const FEBRUARY = {
  code: 2,
  label: "forms.meeting.constants.february",
};
export const MARCH = {
  code: 3,
  label: "forms.meeting.constants.march",
};
export const APRIL = {
  code: 4,
  label: "forms.meeting.constants.april",
};
export const MAY = {
  code: 5,
  label: "forms.meeting.constants.may",
};
export const JUNE = {
  code: 6,
  label: "forms.meeting.constants.june",
};
export const JULY = {
  code: 7,
  label: "forms.meeting.constants.july",
};
export const AUGUST = {
  code: 8,
  label: "forms.meeting.constants.august",
};
export const SEPTEMBER = {
  code: 9,
  label: "forms.meeting.constants.september",
};
export const OCTOBER = {
  code: 10,
  label: "forms.meeting.constants.october",
};
export const NOVEMBER = {
  code: 11,
  label: "forms.meeting.constants.november",
};
export const DECEMBER = {
  code: 12,
  label: "forms.meeting.constants.december",
};

export const MONTHS = [
  JANUARY,
  FEBRUARY,
  MARCH,
  APRIL,
  MAY,
  JUNE,
  JULY,
  AUGUST,
  SEPTEMBER,
  OCTOBER,
  NOVEMBER,
  DECEMBER,
];

export const SPAIN = {
  code: 205,
  label: "forms.course.constants.spain",
};
export const PORTUGAL = {
  code: 176,
  label: "forms.course.constants.portugal",
};

export const COUNTRIES = [SPAIN, PORTUGAL];
